import Backbone from 'backbone/backbone'
import _ from 'underscore/underscore'
import imagesLoaded from 'imagesloaded/imagesloaded.pkgd.min.js'

import BaseView from 'front/components/BaseView/BaseView.js'


var PageView = BaseView.extend({
    initialize (options) {
        this.views = {}

        if (options.prerendered) {
            this.promise = new Promise((resolve) => {
                resolve()
            })
            this.activate()
        } else {
            this.promise = options.promise
            this.loadData()
                .then(() => {
                    this.render()
                })
                .then(() => {
                    this.activate()
                })
        }
    },

    loadData () {
        return Promise.resolve($.getJSON(this.apiUrl, {lang: app.data.lang})
            .then((data) => {
                this.data = data
            })
            .fail(() => {
                console.log('Ошибка при загрузке данных.')
            }))
    },

    render() {
        let $html = $(this.template.render(this.data))
        app.els.$content.append($html)
        this.setElement($html)

        return this
    },

    preloadImages() {
        let $preloads = this.$('.u-Preload')
        let images = this.$('img').toArray()

        _.each($preloads, (item) => {
            let $item = $(item)
            let $img = $item.filter('img')

            if (!$img.length) {
                $img = $item.find('img')

                let imageUrl

                if (app.isRetina && $img.attr('srcset')) {
                    imageUrl = $img.attr('srcset').split(' ')[0]
                } else {
                    imageUrl = $img.attr('src')
                }

                $item.css('background-image', `url(${imageUrl})`)
            }

            images.push($img[0])
        })

        return new Promise(
            (resolve) => {
                imagesLoaded(images, () => {
                    resolve()
                })
            }
        )
    },

    _getBgImage($el) {
        return $el.css('background-image').replace(/^url|[\(\)]/g, '')
    },

    activate() {
        return this.prepare()
            .then(() => {
                return this.playIn()
            })
    },

    deactivate() {
        return this.playOut()
            .then(() => {
                return this.cleanUp()
            })
    }
})

export default PageView


// WEBPACK FOOTER //
// ./assets/app/front/components/PageView/PageView.js